import React from 'react';
import { Pill as TPill } from '../../../domain/status';
import { PillPackage } from './PillPackage';
import { DragOrigin } from './Pill';

interface IPillsProps {
    availablePills: Array<TPill & {amount: number}>;
    onPutPack: (pill: TPill) => void;
    removePillFromOrigin(pill: TPill, origin: DragOrigin): void;
}

export const Pills: React.FunctionComponent<IPillsProps> = props => {
    return (
        <div>
            <div style={{ display: 'inline-flex' }} id="pillstash">
                {props.availablePills.map((p, i) => (
                    <PillPackage
                        pill={p}
                        availableAmount={p.amount}
                        key={i}
                        onDrop={props.onPutPack}
                        removePillFromOrigin={props.removePillFromOrigin}
                    />
                ))}
            </div>
        </div>
    );
};
